import { render } from "./YourDetailsINV.vue?vue&type=template&id=4c63c648&scoped=true"
import script from "./YourDetailsINV.vue?vue&type=script&lang=js"
export * from "./YourDetailsINV.vue?vue&type=script&lang=js"

import "./YourDetailsINV.vue?vue&type=style&index=0&id=4c63c648&lang=scss"
import "./YourDetailsINV.vue?vue&type=style&index=1&id=4c63c648&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4153154969/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c63c648"]])

export default __exports__